import { useEffect } from "react";
import { Icon } from "@iconify/react";

const BillCRM = ({ show, onClose }) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-30 px-4 bg-zinc-950 bg-opacity-50 flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className="min-w-[374px] w-[374px] sm:w-[629px] md:w-[759px] lg:w-[1014px] xl:w-[1269px] bg-zinc-900 border border-zinc-700 rounded-2xl p-6 shadow-lg relative transition-all duration-300"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <button
          className="bg-neutral-800 hover:bg-neutral-700 text-gray-400 hover:text-gray-200 p-[7px] rounded-lg absolute top-3.5 right-3.5"
          onClick={onClose}
        >
          <Icon icon="ic:round-close" className="text-lg" />
        </button>
        <h3 className="text-xl sm:text-2xl font-bold">BillCRM</h3>
        <h4 className="text-sm sm:text-base font-semibold">
          Software de facturación con funciones CRM
        </h4>
        <p className="text-sm sm:text-base font-light">
          Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Maecenas
          porttitor congue massa. Fusce posuere, magna sed pulvinar ultricies,
          purus lectus malesuada libero, sit amet commodo magna eros quis urna.
          Nunc viverra imperdiet enim. Fusce est. Vivamus a tellus. Pellentesque
          habitant morbi tristique senectus et netus et malesuada fames ac
          turpis egestas. Proin pharetra nonummy pede. Mauris et orci. Aenean
          nec lorem. In porttitor. Donec laoreet nonummy augue. Suspendisse dui
          purus, scelerisque at, vulputate vitae, pretium mattis, nunc. Mauris
          eget neque at sem venenatis eleifend. Ut nonummy.
        </p>
        <div className="flex items-center gap-1">
          <Icon className="w-10 h-10" icon=""></Icon>
        </div>
      </div>
    </div>
  );
};

export default BillCRM;
